import i18n from './i18n';

export const isRtl = () => {
  return i18n.language === 'ar';
};
